// src/components/ProfessionalCandlestickChart.js
import React, { useEffect, useRef } from 'react';
import { createChart } from 'lightweight-charts';

const ProfessionalCandlestickChart = ({ data, darkMode, symbol }) => {
  const chartContainerRef = useRef();
  const chart = useRef();
  const candleSeries = useRef();

  useEffect(() => {
    chart.current = createChart(chartContainerRef.current, {
      layout: {
        backgroundColor: darkMode ? '#1f2937' : '#ffffff',
        textColor: darkMode ? '#d1d5db' : '#333333',
      },
      grid: {
        vertLines: {
          color: darkMode ? '#374151' : '#e5e7eb',
        },
        horzLines: {
          color: darkMode ? '#374151' : '#e5e7eb',
        },
      },
      width: chartContainerRef.current.clientWidth,
      height: 400,
    });

    candleSeries.current = chart.current.addCandlestickSeries({
      upColor: darkMode ? '#10b981' : '#059669',
      downColor: darkMode ? '#ef4444' : '#dc2626',
      borderVisible: false,
      wickUpColor: darkMode ? '#10b981' : '#059669',
      wickDownColor: darkMode ? '#ef4444' : '#dc2626',
    });

    candleSeries.current.setData(data);

    chart.current.timeScale().fitContent();

    const handleResize = () => {
      chart.current.applyOptions({
        width: chartContainerRef.current.clientWidth,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (chart.current) {
        chart.current.remove();
      }
    };
  }, [darkMode, data]);

  useEffect(() => {
    if (candleSeries.current) {
      candleSeries.current.setData(data);
      chart.current.timeScale().fitContent();
    }
  }, [data]);

  return (
    <div className={`rounded-lg p-6 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
      <h3 className="text-xl font-bold mb-4">{symbol} Candlestick Chart</h3>
      <div ref={chartContainerRef} className="w-full h-96" />
    </div>
  );
};

// Format data for lightweight-charts
const formatChartData = (rawData) => {
  return rawData.map(item => ({
    time: new Date(item.time).getTime() / 1000, // Convert to timestamp
    open: item.open,
    high: item.high,
    low: item.low,
    close: item.close,
  }));
};

export default ProfessionalCandlestickChart;